var _path, _use, _use2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBinWithTwoStripes = function SvgBinWithTwoStripes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 31
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.541 9.042a1.29 1.29 0 0 0-1.292 1.292v14.455a2.48 2.48 0 0 1-2.596 2.337H10.346a2.48 2.48 0 0 1-2.596-2.337V10.334a1.29 1.29 0 1 0-2.584 0v14.455a5.06 5.06 0 0 0 5.18 4.92h10.308a5.06 5.06 0 0 0 5.18-4.92V10.334a1.29 1.29 0 0 0-1.292-1.292zm1.292-3.875h-5.167V2.584a1.29 1.29 0 0 0-1.292-1.292h-7.75a1.29 1.29 0 0 0-1.292 1.292v2.583H5.167a1.29 1.29 0 1 0 0 2.583h20.667a1.29 1.29 0 1 0 0-2.584zm-12.917 0V3.875h5.167v1.292z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bin-with-two-stripes_svg__a"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bin-with-two-stripes_svg__a",
    x: 5.166
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bin-with-two-stripes_svg__a",
    d: "M14.208 21.958v-9.042a1.29 1.29 0 0 0-1.292-1.292 1.29 1.29 0 0 0-1.292 1.292v9.042a1.29 1.29 0 0 0 1.292 1.292 1.29 1.29 0 0 0 1.292-1.292"
  }))));
};
export default SvgBinWithTwoStripes;